<template>
  <div>
    <div class="features-boxed">
      <div class="container" style="font-family:Basic, sans-serif;">
          <div class="intro">
              <h2 class="text-center" style="
                  font-family: Basic, sans-serif;
                  color: rgb(94, 13, 116);
                  font-weight: bold;
                  margin-bottom: 40px;
                  padding-top: 40px;
                  font-size: 2rem;
                ">Área do Doador</h2>
              <p class="text-left" style="font-family:Basic, sans-serif;width:700px;margin:-50px;color:#5e0d74;">
                <strong>Bem-Vindo.</strong><br>
                Olá, {{donatorName}}<br> <br>
                Este espaço foi criado para facilitar o seu relacionamento com a Fundação do Câncer. Aqui você poderá alterar a forma e o valor da sua contribuição, enviar o seu depoimento, entre outros
                  serviços. Mantenha sempre seus dados pessoais e de pagamento atualizados para que a sua doação seja efetuada corretamente. A Fundação do Câncer agradece o seu apoio.<br><strong>        Clique nos ícones abaixo e escolha a opção desejada.</strong><br><br></p>
          </div>
          <div class="row justify-content-center features">
              <!--
              <div class="col-sm-6 col-md-5 col-lg-4 item">
                  <div class="box" style="height:235px;">
                    <font-awesome-icon class='icon' icon="fa-credit-card-alt" style="color:rgb(94,13,116);font-size:70px;"/>
                    <h3 class="name" style="font-family:Basic, sans-serif;">
                      <router-link data-cy="payment-area" to="/payment-area">Atualize Seus Dados de Pagamento</router-link>
                    </h3>
                  </div>
              </div>
              -->
              <div class="col-sm-4 col-md-3 col-lg-5 item">
                  <div class="box" style="height:235px;">
                    <font-awesome-icon class='icon' icon="fa-user-circle" style="color:#5e0d74;font-size:70px;"/>
                    <h3 class="name" style="font-family:Basic, sans-serif;color:#5e0d74;">
                      <router-link data-cy="personal-data" to="/mf/doador/editar">Atualize Seus Dados Cadastrais</router-link>
                    </h3>
                  </div>
              </div>
              <div class="col-sm-4 col-md-3 col-lg-5 item">
                  <div class="box" style="height:235px;">
                    <font-awesome-icon class='icon' icon="fa-barcode" style="font-size:70px;color:#5e0d74;"/>
                      <h3 class="name" style="font-family:Basic, sans-serif;">
                        <router-link data-cy="extract" to="/mf/minhas-doacoes">Minhas doações</router-link>
                      </h3>
                  </div>
              </div>
              <div class="col-sm-4 col-md-3 col-lg-5 item">
                  <div class="box" style="height:235px;">
                    <font-awesome-icon class='icon' icon="fa-money-bill" style="color:#5e0d74;font-size:70px;"/>
                    <h3 class="name" style="font-family:Basic, sans-serif;">
                      <router-link data-cy="new-donation" to="/mf/doe_agora">Fazer uma doação</router-link>
                    </h3>
                  </div>
              </div>
              <div class="col-sm-4 col-md-3 col-lg-5 item">
                  <div class="box" style="height:235px;">
                    <font-awesome-icon class='icon' icon="fa-bullhorn" style="font-size:70px;color:#5e0d74;"/>
                      <h3 class="text-primary name" style="font-family:Basic, sans-serif;">
                      <router-link data-cy="nossas-campanhas" to="/mf/campanhas">Nossas campanhas</router-link></h3>
                  </div>
              </div>
          </div>
      </div>
    </div>

  </div>
</template>
<style type="text/css">
    @import url("https://donatorarea.s3.amazonaws.com/assets/bootstrap/css/bootstrap.min.css");
    @import url("https://donatorarea.s3.amazonaws.com/assets/css/Features-Boxed.css");
    @import url("https://donatorarea.s3.amazonaws.com/assets/css/styles.css");
    @import url("https://donatorarea.s3.amazonaws.com/assets/css/font-awesome.min.css");
    *, input, select, button {
        font-family: 'Basic',Helvetica,Arial,Lucida,sans-serif;
    }
    input, select{
        padding:4px;
        border: 2px solid #55006D;
    }
    a,a:hover{
        text-decoration: underline;
    }
    .error{
        color:red;
        text-decoration: underline;
    }
    input[type='radio']{
        width: inherit;
        margin: 0;
        padding: 0;
        height: auto;
        margin-right: 5px;
    }
    #debito, #credito{
        text-align: left;
    }
    #extract{
        border: 2px solid #55006D;
        margin: auto;
        margin-top: 20px;
    }
    #extract td, #extract th{
        border: 2px solid #55006D;
        border-collapse: collapse;
        padding:5px;
    }
    .et_pb_image_0,.et_pb_image_1
    {
        width:50%;
        float:left;
    }
    .et_pb_image_0 img,.et_pb_image_1 img
    {
        width:90%;
    }
    h2{
        display: block;
    }
  </style>
<script>
import { setupAxios } from '../../setupAxios';
import { getCurrentUser } from '../../apiClient';
export default {
  name: 'Home',
  data: function () {
    return {
      donatorName: ''
    };
  },
  async mounted () {
    this.axios = setupAxios();
    const res = await getCurrentUser(this.axios);
    this.donatorName = res.name;
  }
};
</script>
